export default __webpack_public_path__ + "static/Screenshot5-6f95bf8e7d3d956b6c81ff12f8ea7489.jpg";